import { authentication } from "@microsoft/teams-js";

/**
 * Opens a popup window via the Teams authentication API.
 * The popup navigates through the normal OAuth flow and the completion
 * page calls `authentication.notifySuccess()` to close itself.
 *
 * @param loginUrl - The URL to open in the popup (e.g. `/login?redirect_uri=/teams-auth-complete`)
 * @returns A promise that resolves on success and rejects on failure/cancellation.
 */
export const teamsAuthPopup = (loginUrl: string): Promise<string> => {
  const url = new URL(loginUrl, window.location.origin);

  if (url.origin !== window.location.origin) {
    return Promise.reject(new Error(`Invalid loginUrl: must be a relative path or same-origin URL`));
  }

  return authentication.authenticate({
    url: url.href,
    width: 768,
    height: 600,
  });
};
